/** @jsx isolateComponent */

import React from 'react';
import { isolateComponent, labelStyles } from '@zapier/common-utils';

type SpacerProps = {
  /**
   * Sets the height of this component. Accepts any valid emotion CSS value for
   * the `height` property.
   */
  height?: string | number;
  /**
   * Sets the width of this component. Accepts any valid emotion CSS value for
   * the `width` property.
   */
  width?: string | number;
};

const Styles = labelStyles(__filename, {
  root: (props: SpacerProps) => [
    {
      label: `${props.width || 0}-by-${props.height || 0}`,
      width: props.width,
      height: props.height,
    },
  ],
});
/**
 * Adds space between things.
 *
 * As an alternative to adding `margin` directly to a component, `Spacer`
 * allows for space to be added _between_ components without needing to modify
 * their styles, or wrap them in `div`s.
 *
 * Tags: core-ui
 */
const Spacer: React.FC<SpacerProps> = props => {
  return <div css={Styles.root(props)} />;
};

Spacer.defaultProps = {
  width: 0,
  height: 0,
};
export default Spacer;
